
import React, { useEffect, useRef } from 'react';

interface AdComponentProps {
  adSlot: string;
  adFormat?: 'auto' | 'rectangle' | 'horizontal' | 'vertical';
  className?: string;
}

const AdComponent: React.FC<AdComponentProps> = ({ 
  adSlot,
  adFormat = 'auto',
  className = ''
}) => {
  const adRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    // Only run this in the browser, not during SSR
    if (typeof window === 'undefined') return;
    
    // Make sure the Google AdSense script is loaded
    if (window.adsbygoogle) {
      try {
        // This pushes a command to the adsbygoogle array to initialize the ad
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        console.log("AdSense ad pushed to queue:", adSlot);
      } catch (error) {
        console.error("Error initializing AdSense ad:", error);
      }
    } else {
      console.warn("AdSense script not loaded yet");
    }
    
    // Cleanup function
    return () => {
      // Any cleanup if needed
    };
  }, [adSlot]);

  return (
    <div className={`ad-container my-4 overflow-hidden ${className}`} ref={adRef}>
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-7694518284762748"
        data-ad-slot={adSlot}
        data-ad-format={adFormat}
        data-full-width-responsive="true"
      ></ins>
    </div>
  );
};

export default AdComponent;

// Add this to the global window object to make TypeScript happy
declare global {
  interface Window {
    adsbygoogle: any[];
  }
}
